import { useTranslation } from "react-i18next";

type Props = {
  errors: any;
};

enum ValidationTypes {
  internal = "internal",
  regex = "regex",
}

export const ExportsValidationErrors = ({ errors }: Props) => {
  const { t } = useTranslation();

  if (errors.length === 0) {
    return null;
  }

  const errorMessages = errors
    .map(
      (error: {
        name: string;
        value: string;
        regex: string;
        validation: string;
        message: string;
      }) => {
        if (error.validation === ValidationTypes.internal) {
          return error.message;
          // biome-ignore lint/style/noUselessElse: biome is not able to understand the context of the code
        } else if (error.validation === ValidationTypes.regex) {
          if (error.message === "Invalid") {
            return t("exports.errors.validations", {
              name: error?.name,
              value: error?.value,
              regex: error?.regex,
            });
          }
          return error.message;
        }
        return t("exports.errors.unknown");
      },
    )
    .join("\n");

  return (
    <p
      className="whitespace-pre-line"
      // biome-ignore lint/security/noDangerouslySetInnerHtml: This is a controlled environment
      dangerouslySetInnerHTML={{
        __html: errorMessages,
      }}
    />
  );
};
